import HeroSkeleton from "./HeroSkeleton";
import NewsSkeleton from "./NewsSkeleton";
import CardsSkeleton from "./CardsSkeleton";
import AboutCardsSkeleton from "./AboutCardsSkeleton";
import UserCardSkeleton from "./UserCardSkeleton";
import BookDetailsSkeleton from "./BookDetailsSkeleton";
import HorizontalCardSkeleton from "./HorizontalCardSkeleton";
import AdvancedSearchSkeleton from "./AdvancedSearchSkeleton";
import Paragraph from "./Paragraph";

const Skeletons = {
  HeroSkeleton,
  NewsSkeleton,
  CardsSkeleton,
  AboutCardsSkeleton,
  UserCardSkeleton,
  BookDetailsSkeleton,
  HorizontalCardSkeleton,
  AdvancedSearchSkeleton,
  Paragraph
};

export default Skeletons;
